import { regionOptions, yearOptions, sortOptions } from '@/data/videos';

interface FilterPanelProps {
  region: string;
  yearRange: string;
  sortBy: string;
  resultCount: number;
  onRegionChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

interface FilterGroupProps {
  title: string;
  options: { label: string; value: string }[];
  active: string;
  onChange: (value: string) => void;
}

function FilterGroup({ title, options, active, onChange }: FilterGroupProps) {
  return (
    <div className="border-b border-background-200 pb-5 last:border-b-0 last:pb-0">
      <h3 className="mb-3 font-heading text-xs font-semibold uppercase tracking-[0.12em] text-foreground-500">
        {title}
      </h3>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
              active === option.value
                ? 'bg-primary-500 font-medium text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  region,
  yearRange,
  sortBy,
  resultCount,
  onRegionChange,
  onYearChange,
  onSortChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between">
        <span className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-equalizer-line text-base text-accent-600" />
          筛选条件
        </span>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-accent-600"
        >
          重置
        </button>
      </div>

      <div className="space-y-5">
        <FilterGroup
          title="地区"
          options={regionOptions.map((value) => ({ label: value, value }))}
          active={region}
          onChange={onRegionChange}
        />
        <FilterGroup
          title="年份"
          options={yearOptions}
          active={yearRange}
          onChange={onYearChange}
        />
        <FilterGroup
          title="排序"
          options={sortOptions}
          active={sortBy}
          onChange={onSortChange}
        />
      </div>

      <p className="mt-5 rounded-md bg-secondary-50 px-3 py-2.5 text-xs text-secondary-800">
        当前筛选结果：<span className="font-semibold">{resultCount}</span> 部影片
      </p>
    </div>
  );
}